import request from './request'

const DOMAIN_PATH_CONFIG = {
  dev: 'http://agent-api.zc.dev.myyixue.com/agentmanageapi/api',
  test: 'https://agent-api-test.classba.cn/agentmanageapi/api',
  pre: 'https://agent-api-pre.classba.cn/agentmanageapi/api',
  prod: 'https://agent-api.classba.cn/agentmanageapi/api'
};
const SG_DOMAIN_PATH_CONFIG = {
  dev: 'http://agent-api.zc.dev.myyixue.com/sgmanageapi/api',
  test: 'https://agent-api-test.sgbeikao.com/sgmanageapi/api',
  pre: 'https://agent-api-pre.sgbeikao.com/sgmanageapi/api',
  prod: 'https://agent-api.sgbeikao.com/sgmanageapi/api'
};
// 环境域名规则配置
const ENV_DOMAIN_RULES = {
  dev: [
    'fe.dev.myyixue.com',  // 匹配 agent.fe.dev.myyixue.com, teacher.fe.dev.myyixue.com 等
  ],
  test: [
    'myyixue.com',
    'test.classba.cn',
    'test.songshuai.com',
    'test.sgbeikao.com',
  ],
  pre: [
    '-pre.songshuai.com',
    '-pre.classba.cn',
    '-pre.sgbeikao.com',
  ],
  prod: [
    '.songshuai.com',
    '.classba.cn',
    '.sgbeikao.com',
  ]
};

const getCurrentEnv = () => {
  const host = window.location.host;
  
  // 本地环境（本地开发调试使用）
  if (host.includes('localhost')) {
    return 'dev';
  }
  
  // 按优先级检查域名规则：dev > test > pre > prod
  const envs = ['dev', 'test', 'pre', 'prod'];
  for (const env of envs) {
    if (ENV_DOMAIN_RULES[env].some(rule => host.includes(rule))) {
      return env;
    }
  }
  
  // 默认为生产环境
  return 'prod';
};

// 判断是否为松果域名（包含 sg- 或 sgbeikao.com）
const isSgDomain = () => {
  const host = window.location.host;
  return host.includes('sg-') || host.includes('sgbeikao.com');
};

// 获取当前环境的 BASE_URL
const BASE_URL = isSgDomain() 
  ? SG_DOMAIN_PATH_CONFIG[getCurrentEnv()]
  : DOMAIN_PATH_CONFIG[getCurrentEnv()];

// 七鱼工单列表查询
const queryWorkSheetList = (data) => {
    return request({
        url: BASE_URL + '/qiyukf/queryWorkSheetList',
        method: 'post',
        data: data
    });
}
// 七鱼工单详情查询
const getWorkSheet = (data) => {
    return request({
        url: BASE_URL + '/qiyukf/getWorkSheet',
        method: 'post',
        data
    });
}
// 七鱼修改工单已读
const updateWorkSheetRead = (data) => {
    return request({
        url: BASE_URL + '/qiyukf/updateWorkSheetRead',
        method: 'post',
        data
    });
}
// 获取工单未读数
const queryWorkSheetUnReadCount = (data) => {
  return request({
    url: BASE_URL + '/qiyukf/queryWorkSheetUnReadCount',
    method: 'post',
    data
  });
};
// 获取客服未读消息数
const queryCustomerSheetUnReadCount = (data) => {
  return request({
    url: BASE_URL + '/qiyukf/querycustomersheetunreadcount',
    // url: BASE_URL + '/qiyukf/queryWorkSheetUnReadCount',
    method: 'post',
    data
  });
};
// 修改客服已读
const updateCustomerSheetRead = (data) => {
    return request({
        url: BASE_URL + '/qiyukf/updatecustomersheetread',
        method: 'post',
        data
    });
}

export {
  getWorkSheet,
  queryWorkSheetList,
  updateWorkSheetRead,
  queryWorkSheetUnReadCount,
  updateCustomerSheetRead,
  queryCustomerSheetUnReadCount,
}